import React, { Component } from 'react';
import { Modal } from 'carbon-components-react';
import { toast } from 'react-toastify';
import queryString from 'qs';
import { TableDefault } from '../../../../components';
import { PREPARACAO, ENTREGUE, PRONTAENTREGA, CANCELADO } from '../../../../config/StatusRequest';
import { pathDmService } from '../../../../services/Api';

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      pageSize: 100,
      totalItems: 0,
      typeCleark: 1,
      type: null,
      orderBy: 'DataSolicitacao',
      // orderDirection: '',
      // urlDelete: '/Pedido/Delete',
      urlEdit: '/admin/trade/brinde/:id/todos',
      urlLoad: '/Pedido/GetBrindesAtendente',
      // messageNextModal: 'Você tem certeza que deseja alterar o status do pedido',
      actionModal: false,
      numberRequest: null,
      statusRequest: null,
      newStatusRequest: null,
      selectedFilter: null,
      dataRow: {},
    };
  }

  componentWillMount() {
    this.setUrlReturn();
  }

  setUrlReturn = () => {
    const { history } = this.props;
    localStorage.setItem('urlReturn', history.location.pathname);
  };

  setSatus = status => {
    let newStatus = {};
    switch (status) {
      case 'Pendente':
        newStatus = PREPARACAO;
        break;
      case 'Preparação':
        newStatus = PRONTAENTREGA;
        break;
      case 'Pronto para Entrega':
        newStatus = ENTREGUE;
        break;
      case 'Entregue':
        newStatus = CANCELADO;
        break;
      default:
        newStatus = null;
        break;
    }

    this.setState({
      newStatusRequest: newStatus,
    });
  };

  actionNext = event => {
    this.setSatus(event.cells[5].value);
    this.setState(prevState => ({
      actionModal: !prevState.actionModal,
      selectedId: null,
      numberRequest: event.cells[0].value,
      statusRequest: event.cells[5].value,
      dataRow: event,
    }));
  };

  closeModalNext = () => {
    this.setState({
      actionModal: false,
    });
  };

  updateStatus = async () => {
    const { dataRow, newStatusRequest } = this.state;

    const url = `/Pedido/AtualizaStatus/${dataRow ? dataRow.id : null}?status=${newStatusRequest ? newStatusRequest.id : null}&retirouUniforme=&dataRetiradaUniforme=`;

    pathDmService(url, {})
      .then(async () => {
        toast.success('Status atualizado com sucesso.');
        await this.listRef.getItems();
        this.setState({ actionModal: false });
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar atualizar o status.');
      });
  };

  render() {
    const { defaultFilters } = this.props;
    const query = queryString.parse(defaultFilters);
    const {
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      actionModal,
      numberRequest,
      statusRequest,
      newStatusRequest,
      dataFilter,
      selectedFilter,
      type,
      typeCleark,
    } = this.state;

    return (
      <div className="table-uniforms">
        <TableDefault
          search={search}
          onRef={ref => {
            this.listRef = ref;
          }}
          defaultFilters={defaultFilters}
          typeCleark={query.cancelados ? null : typeCleark}
          type={type}
          order={order}
          orderBy={orderBy}
          pageSize={pageSize}
          totalItems={totalItems}
          urlDelete={urlDelete}
          urlEdit={urlEdit}
          urlLoad={urlLoad}
          actionNext={query.cancelados ? null : this.actionNext}
          idxStatus={4}
          dataFilter={dataFilter}
          selectedFilter={selectedFilter}
          {...this.props}
        />

        <Modal
          open={actionModal}
          onRequestSubmit={async () => this.updateStatus()}
          onRequestClose={() => this.closeModalNext()}
          modalHeading="Alteração de Status"
          primaryButtonText="Confirmar"
          secondaryButtonText="Cancelar"
        >
          <div>
            <p>
              Você tem certeza que deseja alterar o status do pedido
              {' '}
              <br />
              <strong>{numberRequest}</strong>
              {' '}
              de
              <strong>
                {' '}
                {statusRequest}
                {' '}
              </strong>
              {' '}
              para
              {' '}
              <strong>{newStatusRequest ? newStatusRequest.value : null}</strong>
              ?
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}
export default Items;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Gifts/Items.js